import clsx from "clsx";
import React from "react";
import { buildInfo } from "common/services";
import styles from "./VersionFooter.module.scss";

interface VersionFooterProps {
  className?: string;
}

/**
 * Renders the build stamp (`yyyy.MM.dd.HH.mm.ss.<pipeline>`, UTC) in the corner of every page.
 *
 * <p>This is a support tool first and a vanity string second: when a user reports "the page is
 * broken", the stamp answers "which bundle are they actually running" in one screenshot —
 * which matters precisely because a CDN can keep serving an old bundle long after a deploy.
 * The tooltip carries the commit, branch and build instant for anyone who needs to map it back
 * to a pipeline.
 */
export const VersionFooter: React.FC<VersionFooterProps> = ({ className }) => (
  <div className={clsx(styles.versionFooter, className)} data-testid="version-footer">
    <span
      className={styles.stamp}
      title={`build ${buildInfo.version}\ncommit ${buildInfo.commit}\nbranch ${buildInfo.branch}\nbuilt ${buildInfo.builtAt}`}
    >
      v{buildInfo.version}
    </span>
  </div>
);
